import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { BIOBANK_SOURCES } from '../../constants';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';
import { WeightTable } from '../shared/WeightTable';

export const VdaScoreBiobank: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const sourcesText = BIOBANK_SOURCES.join(', ');
  
  const introMath = createMathML(`
    <mrow>
      <mtext>The set B of BIOBANK sources is defined as:</mtext>
    </mrow>
  `, 'inline');

  const setDefinition = createMathML(`
    <mrow>
      <mi>B</mi>
      <mo>=</mo>
      <mo stretchy="true" form="prefix">&#123;</mo>
      <mrow>
        <mi>${sourcesText}</mi>
      </mrow>
      <mo stretchy="true" form="postfix">&#125;</mo>
    </mrow>
  `);

  const subsetDefinition = createMathML(`
    <mrow>
      <mtext>Given a subset</mtext>
      <mspace width="0.222em" />
      <msub>
        <mi>S</mi>
        <mi>B</mi>
      </msub>
      <mo>,</mo>
      <mspace width="0.222em" />
      <msub>
        <mi>S</mi>
        <mi>B</mi>
      </msub>
      <mspace width="0.222em" />
      <mo>⊆</mo>
      <mspace width="0.222em" />
      <mi>B</mi>
      <mo>,</mo>
      <mspace width="0.222em" />
      <msub>
        <mi>W</mi>
        <mi>B</mi>
      </msub>
      <mspace width="0.222em" />
      <mtext>is defined as:</mtext>
    </mrow>
  `, 'inline');

  const weightConditions = [
    { weight: 0.2, condition: '|S_B| > 0' },
    { weight: 0, condition: '|S_B| = 0' },
  ];

  return (
    <div className={className} style={style}>
      <MathMLRenderer mathML={introMath} />
      <MathMLRenderer mathML={setDefinition} />
      <MathMLRenderer mathML={subsetDefinition} className="pl-4" />
      <WeightTable variable="B" conditions={weightConditions} />
    </div>
  );
};